<template>
	<div class="PlatformAccountsAccountLine" :platform="platform">
		<div class="aal-info">
			<div class="aal-logo">

			</div>
			<div class="aal-text">
				<div class="aal-name">
					<v-text-field  hide-details v-model="name" ></v-text-field>
				</div>
				<div class="aal-summary">
					Marka Bilgini added 5 months ago, used in 0 Zaps
				</div>
			</div>
		</div>
		<div class="aal-actions">
			<v-btn depressed small loading>Normal</v-btn>
			<v-btn depressed small color="error">Sil</v-btn>
			<!-- <v-btn depressed small>Normal</v-btn> -->
		</div>
	</div>
</template>

<script>
export default {
	name : 'PlatformAccountsAccountLine',
	props : {
		platform : {
			type : String
		}
	},
	data: () => ({
		name:  'Facebook Lead Ads Marka Bilgini #4'
	})
}
</script>


<style lang="less">
	.PlatformAccountsAccountLine{
		border: 1px solid #ccc;
		border-radius: 3px;
		margin-bottom : 15px;
		padding : 15px;
		display: flex;
		box-shadow: 0 0 10px #ddd;
		.aal-info{
			flex: 1;
			display: flex; 
			align-items: center;
			margin-right: 1.5rem; 
			min-width: 0;
			.aal-logo{
				width: 32px;
				height: 32px;
				background-size: 32px 32px;
				background-repeat: no-repeat; 
				background-position: center center;
				flex: 0 0 auto; 
				margin-right: 1.5rem;
				@media(max-width:570px){ display:none; }
			}
			.aal-text{
				flex: 1; 
				min-width: 0;
				.aal-name{
					.v-input{
						padding-top: 0px !important;
						margin-top: 0px !important;
						margin-bottom: 8px;
						.v-input__slot::before{
							border-color: rgba(149, 149, 149, 0.42) !important;
						}
						input{
							line-height: 22px;
							padding: 0px 0 ;
							font-size:14px;
							font-weight: 700
						}
					}
				}
				.aal-summary{
					color: #969ea2;line-height: 1.3;font-size: 14px;
					@media(max-width:570px){ display:none; }
				}
			}
		}
		.aal-actions{
			flex-basis: auto;
			text-align: center;
			.v-btn__loading{
				.v-progress-circular{
					width : 17px !important;
					height : 17px !important;
				}
			}
		}
		@media(max-width:900px){
			display: block;
			.aal-actions{
				margin-top: 15px;
			}
		}
		&[platform="facebook"]{
			.aal-logo{
				background-image: url(http://robotic.ajans360.com/storage/images/defaults/facebook.png);
			}
		}
		&[platform="instagram"]{
			.aal-logo{
				background-image: url(http://robotic.ajans360.com/storage/images/defaults/instagram.png);
			}
		}
		&[platform="google"]{
			.aal-logo{
				background-image: url(http://robotic.ajans360.com/storage/images/defaults/google.png);
			}
		}
		&[platform="mysql"]{
			.aal-logo{
				background-image: url(http://robotic.ajans360.com/storage/images/defaults/mysql.png);
			}
		}
	}
</style>
